export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtFirmaSidlo';
export const NAME = 'SidloFirmy';
